import { SvgIcon, type SvgIconProps } from '@mui/material'
import { type ComponentType, type SVGProps } from 'react'

// Renders a Material Symbol SVG (from `@material-symbols/svg-400`) as a MUI
// SvgIcon, so it behaves exactly like the `@mui/icons-material` components it
// replaces: `color: currentColor`, 1em sizing, and MUI's Button `startIcon`
// auto-sizes it (18px for size="small").
//
// `inheritViewBox` is REQUIRED: Material Symbols ship a `0 -960 960 960` viewBox,
// not MUI's default `0 0 24 24` — without it the glyph is cropped to a sliver.
//
// Prefer the named icon exports (e.g. `<ExploreIcon />`) over using this
// directly — they bind the right SVG + `-fill` variant. This is the escape
// hatch for a glyph that doesn't have a named export yet.
interface MaterialSymbolProps extends Omit<SvgIconProps, 'component' | 'children'> {
  icon: ComponentType<SVGProps<SVGSVGElement>>
}

export function MaterialSymbol({ icon, ...props }: MaterialSymbolProps) {
  return <SvgIcon component={icon} inheritViewBox {...props} />
}
